<template>
  <CenteredContent :class="$style.desktopMain">
    <Logo :class="$style.homeLogo"/>
    <div :class="$style.homeTitle">
      Welcome
    </div>
    <div>
      <BaseButton button-style="RoundCentered"
                  @click="startHandler">
        <span>Start Order</span>
      </BaseButton>
    </div>
  </CenteredContent>
</template>

<script>
import Component from 'vue-class-component';
import { Action } from 'vuex-class';
import Vue from 'vue';
import CenteredContent from '@/layouts/CenteredContent';
import Logo from '@/components/Logo';
import BaseButton from '@/components/BaseButton';
import { ORDER_SET_RESTAURANT } from '@/apps/cart/store/types';

/**
 * Index page for default layout.
 */
@Component({
  name:       'DesktopMain',
  components: {
    CenteredContent,
    Logo,
    BaseButton,
  },
})
export default class DesktopMain extends Vue {
  @Action(ORDER_SET_RESTAURANT) setOrderRest;

  /**
   * Handler for click on "Start Order" button
   */
  startHandler() {
    this.$router.push({ name: 'restaurant-picker' });
  }

  /**
   * reset selected rest
   */
  mounted() {
    this.setOrderRest(null);
  }
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";

.desktopMain {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.homeLogo {
  margin-bottom: 27px;
  text-align: center;
  max-width: 169px;
}

.homeTitle {
  color: $white;
  font-family: 'Dekers', sans-serif;
  font-weight: 700;
  font-size: 17px;
  text-align: center;
  margin-bottom: 29px;
}

</style>



// WEBPACK FOOTER //
// src/apps/desktop/components/DesktopMain.vue